import { View } from 'backbone.marionette';

import template from './index.jst';
import UserModel from '../../../../models/User';
import Preloader from '../../../../utils/Preloader/index';

class PasswordResetConfirmationView extends View {

	get template() {
		return template;
	}

	get className() {
		return "onboarding-form onboarding-password-reset-confirmation";
	}

	ui() {
		return {
			resend: '.js-resend',
			login : '.js-login'
		};
	}

	events() {
		return {
			'click @ui.resend': 'onClickResend',
			'click @ui.login': 'onClickLogin',
		};
	}

	initialize() {
		this.onboarding = this.getOption('onboarding');

		this.setListeners();
	}

	setListeners() {
		this.listenTo(UserModel, 'user:password_reset:fail', this.onUserPasswordResetFail);
	}

	onClickResend(e) {
		e.preventDefault();
		this.submit();
	}

	onClickLogin(e) {
		e.preventDefault();
		this.onboarding.set({
			current_step: 'LinkAccount'
		});
	}

	async submit() {
		Preloader.show();

		await UserModel.passwordReset({
			email: this.onboarding.get('user_password_reset_email')
		});

		Preloader.hide();
	}

	onUserPasswordResetFail() {
		alert('Something went wrong while trying to reset your password');
	}
}

export default PasswordResetConfirmationView;